export const useSearchParam = (target: string): string | undefined => {
  const search = new URLSearchParams(window.location.search)
  const targetSearchParam = search.get(target)

  if (targetSearchParam === null) {
    return undefined
  }

  return Array.isArray(targetSearchParam) ? targetSearchParam[0] : targetSearchParam
}
